import type { PostType } from '~/shared/types/post-type';

export function paginatePublicPosts(items: PostType[], page: number, perPage: number, sort: string, title = '') {
  const needle = title.trim().toLocaleLowerCase();
  const filtered = items.filter((post) => !needle || post.title.toLocaleLowerCase().includes(needle));
  filtered.sort((a, b) => {
    const result = sort.startsWith('TITLE')
      ? a.title.localeCompare(b.title)
      : Date.parse(a.createdAt ?? '') - Date.parse(b.createdAt ?? '');
    return sort.endsWith('DESC') ? -result : result;
  });
  const pageCount = Math.max(1, Math.ceil(filtered.length / perPage));
  const currentPage = Math.min(Math.max(1, page), pageCount);
  return {
    items: filtered.slice((currentPage - 1) * perPage, currentPage * perPage),
    pageInfo: {
      currentPage,
      perPage,
      pageCount,
      itemCount: filtered.length,
      hasPreviousPage: currentPage > 1,
      hasNextPage: currentPage < pageCount,
    },
  };
}
